var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { prepareZXingModule, readBarcodes } from 'zxing-wasm/reader';
// Serve the decoder from our own bundle instead of the default jsDelivr CDN
const wasmUrl = new URL('zxing-wasm/reader/zxing_reader.wasm', import.meta.url).href;
let preparing = null;
export const prepareQrReader = () => {
    if (!preparing) {
        // the overloads lose the literal `fireImmediately: true`, Promise.resolve keeps the typing simple
        preparing = Promise.resolve(prepareZXingModule({
            overrides: {
                locateFile: (path, prefix) => (path.endsWith('.wasm') ? wasmUrl : prefix + path),
            },
            fireImmediately: true,
        })).catch((e) => {
            preparing = null;
            throw e;
        });
    }
    return preparing;
};
export const readQrText = (image) => __awaiter(void 0, void 0, void 0, function* () {
    const results = yield readBarcodes(image, { tryHarder: true, formats: ['QRCode'], maxNumberOfSymbols: 1 });
    return results.length ? results[0].text : null;
});
